import type { FC } from "react";
import { memo } from "react";

import type {
    IntentSignalEventDto } from "app/pages/sales-intelligence/modules/company-analysis/types/signals";
import {
    isIntentSignalCompanyEvent,
    isIntentSignalDomainsEvent,
} from "app/pages/sales-intelligence/modules/company-analysis/types/signals";

import IntentSignalCompanyEventTopics from "./IntentSignalEventTopics/IntentSignalCompanyEventTopics";
import IntentSignalDomainsEventTopics from "./IntentSignalEventTopics/IntentSignalDomainsEventTopics";

type Props = {
    signal: IntentSignalEventDto;
};

const IntentSignalEventInfoBox: FC<Props> = ({ signal }) => {
    if (isIntentSignalCompanyEvent(signal)) {
        return <IntentSignalCompanyEventTopics signal={signal} />;
    }

    if (isIntentSignalDomainsEvent(signal)) {
        return <IntentSignalDomainsEventTopics signal={signal} />;
    }

    return null;
};

export default memo(IntentSignalEventInfoBox);
